<template>
  <a-row :gutter="12" :class="['introduction', isDesktop ? 'desktop' : 'mobile']">
    <a-col :span="isDesktop ? 20 : 24">
      <a-card class="style3 reset-padding" :title="$t('cardTitle.howToUseThisWizard')">
        <iframe src="https://player.vimeo.com/video/465866423" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </a-card>
    </a-col>

    <a-col :span="isDesktop ? 20 : 24">
      <a-card :title="$t('cardTitle.videoPlayerForYourChurchWebsite')" class="style3 videoPlayer">
        <template v-if="!isSubmitEmbed">
          <a-form :form="form" @submit="doSubmitDomain" class="mb-3">
            <p v-text="$t('page.videoPlayer.videoPlayerForYourChurchWebsite.para1')"></p>
            <a-input :placeholder="$t('placeholder.yourChurchWebsiteAddress')" v-model="domainName" size="large">
              <a-select v-model="prefix" slot="addonBefore" style="width: 90px">
                <a-select-option value="http://">http://</a-select-option>
                <a-select-option value="https://">https://</a-select-option>
              </a-select>
            </a-input>
            <div class="multiple mt-3">
              <a-button type="primary" htmlType="submit" :disabled="!isValidDomain" class="button-generate">{{ $t('button.nextSelectCategories') }}</a-button>
            </div>
          </a-form>
        </template>
        <template v-else>
          <p v-text="$t('page.videoPlayer.videoPlayerForYourChurchWebsite.para2')"></p>
          <a-checkbox-group v-model="cateSelected" class="custom-checkbox" :options="cateList" />
          <p class="mt-3 mb-0">{{ $t('page.videoPlayer.videoPlayerForYourChurchWebsite.para3') }}:</p>
          <a-input class="mb-3" :placeholder="$t('placeholder.yourDonationPageAddress')" v-model="donationLink" />
          <div class="multiple">
            <a-button type="primary" class="button-generate" @click="backToDomain">{{ $t('button.back') }}</a-button>
            <a-button type="primary" class="button-generate" @click="doGeneratedCode">{{ $t('button.nextGenerateEmbedCode') }}</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <template v-if="hasEmbed">
      <a-col :span="isDesktop ? 20 : 24">
        <a-card :title="$t('cardTitle.embedThisCodeInYourwebsite')" class="style3 videoPlayer" style="word-break: break-all">
          {{ dataEmbedUrl }}
          <div class="multiple">
            <a-radio-group v-model="videosEmbedLocale" button-style="solid">
              <a-radio-button value="en"> English </a-radio-button>
              <a-radio-button value="es"> Spanish </a-radio-button>
            </a-radio-group>
            <a-button type="primary" class="button-generate" v-clipboard:copy="dataEmbedUrl" v-clipboard:success="clipboardSuccess">{{ $t('button.copyToClipboard') }}</a-button>
          </div>
        </a-card>
      </a-col>

      <a-col :span="isDesktop ? 20 : 24">
        <a-card :title="$t('cardTitle.previewVideoPlayer')" class="style3">
          <iframe :src="`${this.embedCateUrl}${previewUrl}`" style="border: 0; height: 100vh"></iframe>
        </a-card>
      </a-col>
    </template>

    <!-- Category Specific Players -->
    <a-col :span="isDesktop ? 20 : 24">
      <a-card :title="$t('cardTitle.categorySpecificPlayers')" class="style3 videoPlayer">
        <template>
          <div class="multiple mb-3">
            <a-button type="primary" class="button-generate" @click="isVisibleModal = true">{{ $t('button.createSpecificCategoryEmbed') }}</a-button>
            <a-radio-group v-model="videoLocale" button-style="solid">
              <a-radio-button value="en"> English </a-radio-button>
              <a-radio-button value="es"> Spanish </a-radio-button>
            </a-radio-group>
          </div>

          <template v-if="isGetCustom || !empty(customCateIds)">
            <div class="embedCode" v-for="(customCate, index) in getCusomCate" :key="index">
              <div class="multiple">
                <div class="category">
                  <img :src="customCate.embed_icon" :alt="customCate.name" />
                  <span v-text="customCate.name" />
                </div>
                <a-button type="primary" class="button-generate" v-clipboard:copy="customCate.emebed" v-clipboard:success="clipboardSuccess">{{ $t('button.copyToClipboard') }}</a-button>
              </div>
              <div class="code">{{ customCate.emebed }}</div>
            </div>
            <!-- <a-button
            type="primary"
            class="button-generate"
            @click="isVisibleModal = true"
            >Create Specific Category Embed</a-button>-->
          </template>
        </template>
      </a-card>
    </a-col>

    <a-modal v-model="isVisibleModal" :title="$t('cardTitle.specificCategoryEmbed')" centered @ok="handleSubmit" :destroyOnClose="true" :closable="true" :maskClosable="false" class="cate-selection">
      <template slot="footer">
        <a-button key="back" @click="isVisibleModal = false">{{ $t('button.back') }}</a-button>
        <a-button key="submit" type="primary" :loading="isLoading" @click="handleSubmit" :disabled="empty(specificCateSelected)">{{ $t('button.save') }}</a-button>
      </template>
      <a-radio-group v-model="specificCateSelected" class="custom-radio" :options="cateIdList" />
    </a-modal>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
import { map, startsWith, get, includes, find, forEach, difference, replace } from 'lodash';
import CategoryService from '@/services/CategoryService.js';
import EmbedService from '@/services/EmbedService.js';
import isUrl from '@/utils/domainUtil.js';
import { empty } from '@/utils';

export default {
  data: () => ({
    dataEmbed: '',
    domainName: '',
    donationLink: '',
    prefix: 'https://',
    website: '',
    isValidDomain: false,
    isSubmitEmbed: false,
    categories: [],
    cateSelected: [],
    customCateIds: [],
    specificCateSelected: '',
    previewUrl: '',
    error: '',
    isVisibleModal: false,
    isLoading: false,
    isGetCustom: true,
    videoLocale: 'en',
    videosEmbedLocale: 'en',
  }),
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    cateList() {
      return map(this.categories, cate => ({
        label: get(cate, `${this.settings.locale}.name`),
        value: cate.slug,
      }));
    },
    cateIdList() {
      return map(this.categories, cate => ({
        label: get(cate, `${this.settings.locale}.name`),
        value: cate.id,
        disabled: includes(this.customCateIds, cate.id),
      }));
    },
    getCusomCate() {
      const customCate = [];
      forEach(this.customCateIds, cateId => {
        const cate = find(this.categories, item => item.id === cateId);
        if (!empty(cate)) {
          customCate.push({
            name: get(cate, `${this.settings.locale}.name`),
            embed_icon: cate.embed_icon,
            emebed: ` <div class="embed-container" style="position: relative;padding-bottom: 100vh;height: 0;overflow: hidden;max-width: 100%;">
            <iframe src="https://embed.truelife.org/${this.videoLocale}/category/${cate.slug}" style="position: absolute;top:0;left:0;width: 100%;height:100%"></iframe>
          </div>
        `,
          });
        }
      });
      return customCate;
    },
    hasEmbed() {
      return !empty(this.dataEmbed);
    },
    embedCateUrl() {
      return `https://embed.truelife.org/${this.videosEmbedLocale}`;
    },
    dataEmbedUrl() {
      if (!empty(this.dataEmbed)) {
        return replace(this.dataEmbed, '__EMBED_URL__', this.embedCateUrl);
      }
      return null;
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'videoPlayer',
    });
  },
  watch: {
    domainName(val) {
      if (!empty(val) && !startsWith(val, 'http')) {
        this.website = this.prefix + val;
      }
    },
    website(val) {
      if (isUrl(val)) {
        this.isValidDomain = true;
      }
    },
  },
  async mounted() {
    this.previewUrl = `?account_id=${this.user.churchId}`;
    await this.getAccountEmebed();
    this.categories = CategoryService.buildCategory(await CategoryService.getCategories());
    this.cateSelected = this.categories.map(cat => cat.slug);
  },
  methods: {
    empty,
    backToDomain() {
      this.previewUrl = `?account_id=${this.user.churchId}`;
      this.domainName = '';
      this.donationLink = '';
      this.website = '';
      this.isSubmitEmbed = false;
      this.dataEmbed = null;
    },
    doGeneratedCode() {
      const donationParam = this.donationLink ? `&donation_url=${this.donationLink}` : '';
      const cateNotEmebed = difference(
        map(this.categories, cate => cate.slug),
        this.cateSelected,
      );
      const cateNotEmebedParam = empty(cateNotEmebed) ? '' : `cat=${cateNotEmebed.join(',')}&`;
      this.dataEmbed = ` <div class="embed-container" style="position: relative;padding-bottom: 100vh;height: 0;overflow: hidden;max-width: 100%;">
            <iframe src="__EMBED_URL__?${cateNotEmebedParam}account_id=${this.user.churchId}${donationParam}&version=2"
             style="position: absolute;top:0;left:0;width: 100%;height:100%"></iframe>
          </div>
        `;
      this.previewUrl = `?cat=${cateNotEmebed.join(',')}&account_id=${this.user.churchId}${donationParam}`;
    },
    async doSubmitDomain(e) {
      e.preventDefault();
      // domain validation
      if (isUrl(this.domainName)) {
        await EmbedService.setEmbed({ domain: this.domainName, account_id: this.user.churchId });
        this.isSubmitEmbed = true;
      } else {
        this.$notification['warning']({
          message: 'Generate Failed',
          description: 'Invalid website',
        });
      }
    },
    clipboardSuccess() {
      this.$notification['success']({
        message: 'Video Embed Copied',
      });
    },
    async handleSubmit(e) {
      e.preventDefault();
      try {
        this.error = '';
        this.isLoading = true;
        await EmbedService.createAccountEmbed({ category_id: this.specificCateSelected, account_id: this.user.churchId });
        await this.getAccountEmebed();
        this.error = '';
        this.specificCateSelected = '';
        this.isVisibleModal = false;
      } catch (error) {
        console.error({ error });
        this.error = get(error, 'response.data.error', error.message);
      } finally {
        this.isLoading = false;
      }
    },
    async getAccountEmebed() {
      try {
        this.isGetCustom = true;
        const resp = await EmbedService.getAccountEmbed(this.user.churchId);
        this.customCateIds = map(resp, item => item.category_id);
      } catch (error) {
        console.error({ error });
      } finally {
        this.isGetCustom = false;
      }
    },
  },
};
</script>
<style lang="scss">
.videoPlayer {
  .embedCode {
    border: 1px solid #1c84c6;
    margin-bottom: 10px;
    border-radius: 0 5px 0 0;
    .code {
      border: 1px solid #1c84c6;
      padding: 10px;
      margin: 10px;
      border-radius: 5px;
    }
    .category {
      background: #fff;
      transition: all 0.3s;
      span {
        text-transform: uppercase;
        font-weight: 700;
        margin-left: 10px;
      }
      img {
        width: 46px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  .example {
    display: block;
    margin: 10px 0;
  }
  .custom-checkbox {
    display: flex;
    flex-wrap: wrap;
    > label {
      margin: 0;
      flex: 0 0 50%;
    }
  }
  .multiple {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    align-items: center;
    .button-generate {
      display: inline-block;
      margin: initial;
    }
  }
  .button-generate {
    margin: auto;
    margin-top: 30px;
    display: block;
    padding: 10px;
    height: auto;
    min-width: 100px;
  }
}
.cate-selection {
  .custom-radio {
    display: flex;
    flex-wrap: wrap;
    > label {
      font-size: 20px;
      margin: 0;
      flex: 0 0 50%;
    }
  }
}
</style>
